import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, UrlSegment } from '@angular/router';
import { Lang, LangService } from '../services/lang.service';
import { VALID_LANGS } from '../routing/localized-routes';

/** First URL segment must be a valid language (fr | en). */
export const langMatch: CanMatchFn = (_route, segments: UrlSegment[]) => {
  return VALID_LANGS.includes(segments[0]?.path as Lang);
};

/** Sync LangService from :lang without re-navigating. */
export const langSyncGuard: CanActivateFn = (route) => {
  const lang = route.paramMap.get('lang') as Lang;
  const langService = inject(LangService);
  if (VALID_LANGS.includes(lang) && lang !== langService.current) {
    langService.init(lang);
    localStorage.setItem('lang', lang);
  }
  return true;
};
